export const INCLUDE_OPTIONS_MAP = {
  CATEGORY_TEMPLATES: 'CategoryTemplates',
  TEMPLATE_CONTENT: 'TemplateContent',
};

export const UPDATE_TEMPLATE_TYPES_MAP = {
  CATEGORY_AND_NAME: 'CategoryAndName',
  CONTENT: 'Content',
  SUBJECT: 'Subject',
};

export const TEMPLATE_VARIABLES_TITLE = 'Telephony Variables';

export const ALL_LOAN_ROLES_TITLE = 'All Loan Roles';

export const GLOBAL_LOAN_ROLE_SUFFIX = ' (Global)';
